import PropTypes from 'prop-types'
import {
  UserDataContainer,
  UserName,
  UserAvatarContainer
} from '../../styled-components'
import StatusIndicationComponent from '../../../../atoms/status-indication/index.jsx'
import { iconSizeOptions } from '../../../../atoms/icons/icons-sizes'
import { statusIndicationMemberOptions } from '../../../../atoms/status-indication/constants'

const UserData = ({ name, profilePicture, status }) => {
  return (
    <UserDataContainer>
      <UserAvatarContainer>
        <StatusIndicationComponent
          status={status}
          image={profilePicture}
          size={iconSizeOptions['ICON-M']}
        />
      </UserAvatarContainer>

      <UserName>{name}</UserName>
    </UserDataContainer>
  )
}

UserData.propTypes = {
  name: PropTypes.string,
  profilePicture: PropTypes.string,
  status: PropTypes.oneOf(Object.values(statusIndicationMemberOptions))
}

export default UserData
